import { useHistory, useLocation } from "react-router-dom"
import {
  SafetiesAnswerBackType,
  SafetiesAnswerDataDetailType,
} from "../../../../models/answer"
import { Form } from "antd"
import { useState } from "react"
import { SafetiesInfoDataType } from "../../../../models/info"

export const useVariablesApi = () => {
  const { state } = useLocation<SafetiesAnswerBackType>()
  const [form] = Form.useForm()
  const { push } = useHistory()
  const [isLoadingLayout, setIsLoadingLayout] = useState(true)
  const [safetyInfo, setSafetyInfo] = useState<SafetiesInfoDataType>()
  const [safetyDetailInfo, setSafetyDetailInfo] =
    useState<SafetiesAnswerDataDetailType>()

  return {
    form,
    isLoadingLayout,
    push,
    safetyDetailInfo,
    safetyInfo,
    setIsLoadingLayout,
    setSafetyDetailInfo,
    setSafetyInfo,
    state,
  }
}
